<template>
    <v-dialog
        v-if="supplierDialog"
        v-model="supplierDialog"
        persistent
        width="800px"
    >
        <v-form ref="supplierForm">
            <v-card>
                <v-card-title class="primary white--text">
                    <v-icon dark class="mr-2">assignment</v-icon>Update
                    Supplier & Note
                </v-card-title>

                <v-card-text class="pb-0">
                    <v-toolbar class="py-2" outlined flat>
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-toolbar-title
                                    class="title pr-2"
                                    v-on="on"
                                >
                                    {{
                                        growthTask
                                            ? growthTask.plant.name
                                            : ""
                                    }}
                                    <div
                                        class="
                                            mt-n1
                                            grey--text
                                            text--darken-1
                                            caption
                                        "
                                        v-if="growthTask"
                                    >
                                        {{
                                            (growthTask
                                                ? growthTask.growthStartDate
                                                : "1970-01-01")
                                                | moment("YYYY-[W]WW")
                                        }}
                                    </div>
                                </v-toolbar-title>
                            </template>
                            <span>{{
                                growthTask ? growthTask.plant.name : ""
                            }}</span>
                        </v-tooltip>

                        <v-spacer />
                        <v-icon :color="taskColor" class="mr-1">eco</v-icon>
                        <span :class="taskColor + `--text headline`">{{
                            growthTask ? growthTask.totalInventory : 0
                        }}</span>
                    </v-toolbar>
                </v-card-text>

                <v-card-text class="px-5">
                    <!-- supplier order no and supplier -->
                    <v-row class="align-center">
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="growthTask.supplierOrderNo"
                                label="Supplier Order No"
                                outlined
                                class="subtitle-2 mb-n5"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3">
                            <v-text-field
                                v-model="growthTask.unitPurchasePrice"
                                prepend-inner-icon="euro_symbol"
                                label="Purchase Price (unit)"
                                outlined
                                class="subtitle-2 mb-n5"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-autocomplete
                                v-model="chosenSupplierID"
                                :items="suppliers.edges"
                                :loading="isLoading"
                                item-text="node.name"
                                item-value="node.id"
                                label="Supplier"
                                class="subtitle-2 mb-n5"
                                clearable
                                outlined
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row class="align-center">
                        <v-col cols="12">
                            <v-textarea
                                v-model="growthTask.note"
                                label="Note"
                                outlined
                                class="subtitle-2 mb-n5"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="mr-5 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text rounded @click="$emit('closeDialog')"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :disabled="!hasPermission('change_growthtask')"
                        outlined
                        rounded
                        color="primary"
                        :loading="isSaving"
                        @click="validateSupplierUpdateForm"
                        >Save</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import helper from "@/utils/helper.js";

    export default {
        name : "UpdateSupplierDialog",
        props : ["supplierDialog","growthTask", "taskColor", "suppliers", "isLoading", "selectedSupplierId", "isSaving"],
        data(){
            return {
                chosenSupplierID : this.selectedSupplierId
            }
        },
        methods : {
            validateSupplierUpdateForm(){
                this.$emit('confirmSupplierUpdateForm', this.$refs.supplierForm.validate())
            }
        },
        created() {
            this.hasPermission = helper.hasPermission;
        },
        watch : {
            chosenSupplierID(){
                this.$emit('newSelectedSupplierId', this.chosenSupplierID)
            }
        }
    }
</script>